import _ from 'lodash'
import { currencyList } from '@/common/demand'

const stringToNumberOrEmptyString = (val) => {
  if (val === '') return ''
  val = Number.parseFloat(val)
  // 小于 0，为 NaN 返回空字符串
  if (!val || Number.isNaN(val) || val <= 0) val = ''
  return val
}

const stringNotZeroToNumberOrEmptyString = (val) => {
  if (val === '') return ''
  val = Number.parseFloat(val)
  // 小于 0，为 NaN 返回空字符串
  if ((!val && val !== 0) || Number.isNaN(val) || val < 0) val = ''
  return val
}

// 付费情况表单控件组合
export default {
  computed: {
    settlementFormItem() {
      return {
        is_pay: {
          visible: true,
          label: '是否付费',
          prop: 'is_pay',
          rules: [
            {
              required: true,
              message: '请选择付费方式',
              trigger: 'change',
            },
          ],
          params: {
            options: [
              {
                value: 1,
                label: '是',
              },
              {
                value: 2,
                label: '否',
              },
            ],
            clearable: true,
            // 非设计项目时，付费情况默认为免费（否）且不可更改
            disabled: !this.isDesign,
          },
        },
        currency: {
          visible: this.isPay && this.isDesign,
          label: '结算币种',
          component: 'radio-group',
          prop: 'currency',
          rules: [
            {
              required: true,
              message: '请选择币种',
              trigger: 'change',
            },
          ],
          params: {
            options: currencyList,
            clearable: true,
            placeholder: '请选择币种',
          },
        },
        exchange_rate: {
          visible: this.isPay && this.isDesign,
          label: '美金兑人民币汇率',
          component: 'input',
          prop: 'exchange_rate',
          rules: [
            {
              required: true,
              message: '汇率不可为空',
              trigger: ['change', 'blur'],
            },
          ],
          params: {
            listeners: {
              change: (val) => {
                this.demand.exchange_rate = _.round(
                  stringToNumberOrEmptyString(val),
                  2,
                )
                // 汇率修改联动更新revenue，cost
                this.updateRevenue({
                  revenue_usd: this.demand.revenue_usd,
                  revenue_cny: this.demand.revenue_cny,
                })
                this.updateCost({
                  cost_usd: this.demand.cost_usd,
                  cost_cny: this.demand.cost_cny,
                })
              },
            },
          },
        },
        revenue_usd: {
          visible: this.isPay && this.isDesign,
          label: 'USD',
          prop: 'revenue_usd',
          component: 'input',
          labelWidth: '60px',
          rules: [
            {
              required: true,
              message: 'USD 不可为空',
              trigger: ['change', 'blur'],
            },
          ],
          params: {
            disabled: this.isCnySettlement || !this.hasSelectCurrency,
            listeners: {
              change: (val) => {
                this.updateRevenue({
                  revenue_usd: val,
                  revenue_cny: this.demand.revenue_cny,
                })
              },
            },
          },
        },
        revenue_cny: {
          visible: this.isPay && this.isDesign,
          label: 'CNY',
          prop: 'revenue_cny',
          component: 'input',
          labelWidth: '60px',
          rules: [
            {
              required: true,
              message: 'CNY 不可为空',
              trigger: ['change', 'blur'],
            },
          ],
          params: {
            disabled: this.isUsdSettlement || !this.hasSelectCurrency,
            listeners: {
              change: (val) => {
                this.updateRevenue({
                  revenue_usd: this.demand.revenue_usd,
                  revenue_cny: val,
                })
              },
            },
          },
        },
        cost_usd: {
          visible: this.isPay && this.isDesign,
          label: 'USD',
          prop: 'cost_usd',
          component: 'input',
          labelWidth: '60px',
          rules: [
            {
              required: true,
              message: 'USD 不可为空',
              trigger: ['change', 'blur'],
            },
          ],
          params: {
            disabled: this.isCnySettlement || !this.hasSelectCurrency,
            listeners: {
              change: (val) => {
                this.updateCost({
                  cost_usd: val,
                  cost_cny: this.demand.cost_cny,
                })
              },
            },
          },
        },
        cost_cny: {
          visible: this.isPay && this.isDesign,
          label: 'CNY',
          prop: 'cost_cny',
          component: 'input',
          labelWidth: '60px',
          rules: [
            {
              required: true,
              message: 'CNY 不可为空',
              trigger: ['change', 'blur'],
            },
          ],
          params: {
            disabled: this.isUsdSettlement || !this.hasSelectCurrency,
            listeners: {
              change: (val) => {
                this.updateCost({
                  cost_usd: this.demand.cost_usd,
                  cost_cny: val,
                })
              },
            },
          },
        },
        is_prepaid: {
          visible: this.isPay && this.isDesign,
          label: '是否预付',
          prop: 'is_prepaid',
          component: 'radio-group',
          rules: [
            {
              required: true,
              message: '请选择是否预付',
              trigger: 'change',
            },
          ],
          params: {
            options: [
              {
                value: 1,
                label: '是',
              },
              {
                value: 2,
                label: '否',
              },
            ],
            clearable: true,
            listeners: {
              change: (val) => {
                if (val === 2) {
                  this.demand.prepaid_percent = ''
                }
              },
            },
          },
        },
        prepaid_percent: {
          visible: this.isPay && this.isDesign && this.isPrepaid,
          label: '预付比例',
          prop: 'prepaid_percent',
          component: 'input',
          rules: [
            {
              required: true,
              message: '请输入预付比例',
              trigger: ['change', 'blur'],
            },
            {
              required: true,
              trigger: ['change', 'blur'],
              validator: (rule, value, callback) => {
                if (_.isNumber(value) && (value < 0 || value > 100)) {
                  callback(new Error('预付比例不可小于 0 或大于 100'))
                }
                callback()
              },
            },
          ],
          params: {
            listeners: {
              change: (val) => {
                this.demand.prepaid_percent = Number.parseInt(val, 10) || ''
              },
            },
          },
        },
        crm_contract_no: {
          visible: this.isPay && this.isDesign,
          label: 'CRM 合同编号',
          prop: 'crm_contract_no',
          component: 'input',
          rules: [
            {
              min: 1,
              max: 200,
              message: 'CRM 合同编号不能超过 200 个字符',
              trigger: 'blur',
            },
          ],
          params: {},
        },
        revenue_summary: {
          visible: this.isPay && this.isDesign,
          label: '推送总 Rev',
          component: 'plain-text',
        },
        cost_summary: {
          visible: this.isPay && this.isDesign,
          label: '推送总 Cost',
          component: 'plain-text',
        },
        cost: {
          visible: true,
          label: '增加Cost',
          prop: 'cost',
          component: 'input',
          rules: [
            {
              required: true,
              message: '请输入增加Cost',
              trigger: ['change', 'blur'],
            },
          ],
          params: {},
        },
        revenue: {
          visible: true,
          label: '增加Rev',
          prop: 'revenue',
          component: 'input',
          rules: [
            {
              required: true,
              message: '请输入增加Rev',
              trigger: ['change', 'blur'],
            },
          ],
          params: {},
        },
      }
    },
  },

  methods: {
    updateRevenue({ revenue_usd, revenue_cny }) {
      const empty = () => {
        this.demand.revenue_usd = ''
        this.demand.revenue_cny = ''
      }
      const update = ({ usd, cny }) => {
        this.demand.revenue_usd = usd
        this.demand.revenue_cny = cny
      }

      const val = stringToNumberOrEmptyString(
        this.isUsdSettlement ? revenue_usd : revenue_cny,
      )

      if (this.isUsdSettlement) {
        if (_.isNumber(val) && _.isNumber(this.demand.exchange_rate)) {
          update({
            usd: _.round(val, 2),
            cny: _.round(
              this.demand.exchange_rate * this.demand.revenue_usd,
              2,
            ),
          })
        } else {
          empty()
        }
      }

      if (this.isCnySettlement) {
        if (_.isNumber(val) && _.isNumber(this.demand.exchange_rate)) {
          update({
            cny: _.round(val, 2),
            usd: _.round(
              this.demand.revenue_cny / this.demand.exchange_rate,
              2,
            ),
          })
        } else {
          empty()
        }
      }
    },

    updateCost({ cost_usd, cost_cny }) {
      const empty = () => {
        this.demand.cost_usd = ''
        this.demand.cost_cny = ''
      }
      const update = ({ usd, cny }) => {
        this.demand.cost_usd = usd
        this.demand.cost_cny = cny
      }

      const val = stringNotZeroToNumberOrEmptyString(
        this.isUsdSettlement ? cost_usd : cost_cny,
      )

      if (this.isUsdSettlement) {
        if (_.isNumber(val) && _.isNumber(this.demand.exchange_rate)) {
          update({
            usd: _.round(val, 2),
            cny: _.round(this.demand.exchange_rate * this.demand.cost_usd, 2),
          })
        } else {
          empty()
        }
      }

      if (this.isCnySettlement) {
        if (_.isNumber(val) && _.isNumber(this.demand.exchange_rate)) {
          update({
            cny: _.round(val, 2),
            usd: _.round(this.demand.cost_cny / this.demand.exchange_rate, 2),
          })
        } else {
          empty()
        }
      }
    },
  },
}
